import { render, staticRenderFns } from "./OnboardingChooseUserConfigurableOptionsModal.vue?vue&type=template&id=e2439bc2"
import script from "./OnboardingChooseUserConfigurableOptionsModal.vue?vue&type=script&lang=js"
export * from "./OnboardingChooseUserConfigurableOptionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports